import React from 'react';

import Confetti from 'react-confetti';
import { useParams } from 'react-router-dom';

import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';

import {
  ButtonBackApp,
  ContainerTitleAndIcon,
  IconConcluded,
  ImageBanner,
  MainSection,
  PaymentComponent,
  TextConcluded,
} from './style';

import concludedIconSVG from '../../../../assets/images/subscripiton-checkout-icons/checked-green-icon.svg';
import biotypeDiagnosisPNG from '../../../../assets/images/checkout-products-images/biotype-diagnosis.png';
import styleDiagnosisPNG from '../../../../assets/images/checkout-products-images/style-diagnosis.png';
import removalBgPNG from '../../../../assets/images/checkout-products-images/removal-bg.png';
import card15Looks from '../../../../assets/images/outfits-montage-icons/card-15-looks.png';
import card10Looks from '../../../../assets/images/outfits-montage-icons/card-10-looks.png';
import card5Looks from '../../../../assets/images/outfits-montage-icons/card-5-looks.png';
import removalBg100PNG from '../../../../assets/images/checkout-products-images/100-removal-bg.png';
import removalBg50PNG from '../../../../assets/images/checkout-products-images/50-removal-bg.png';
import profissionalImagePNG from '../../../../assets/images/checkout-products-images/profissional-image.png';
import suitcase3DaysPNG from '../../../../assets/images/suitcase-3-days.png';
import suitcase7DaysPNG from '../../../../assets/images/suitcase-7-days.png';
import suitcase15DaysPNG from '../../../../assets/images/suitcase-15-days.png';

import semesterPremiumPlanPNG from '../../../../assets/images/subscripiton-checkout-icons/semester-premium-plan-banner.png';
import monthlyPremiumPlanPNG from '../../../../assets/images/subscripiton-checkout-icons/monthly-premium-plan-banner.png';
import semesterBasicPlanPNG from '../../../../assets/images/subscripiton-checkout-icons/semester-basic-plan-banner.png';
import anualPremiumPlanPNG from '../../../../assets/images/subscripiton-checkout-icons/anual-premium-plan-banner.png';
import monthlyBasicPlanPNG from '../../../../assets/images/subscripiton-checkout-icons/monthly-basic-plan-banner.png';
import anualBasicPlanPNG from '../../../../assets/images/subscripiton-checkout-icons/anual-basic-plan-banner.png';

import virtualTryOn10PNG from '../../../../assets/images/checkout-products-images/virtual-try-on-10.png';
import virtualTryOn25PNG from '../../../../assets/images/checkout-products-images/virtual-try-on-25.png';
import virtualTryOn50PNG from '../../../../assets/images/checkout-products-images/virtual-try-on-50.png';

export function PaymentConcluded(): JSX.Element {
  const { platform, typeOrder } = useParams();

  const purchaseImage = (): string => {
    switch (typeOrder) {
      case 'Plano Básico Completo':
        return monthlyBasicPlanPNG;
      case 'Plano Básico Completo Semestral':
        return semesterBasicPlanPNG;
      case 'Plano Básico Completo Anual':
        return anualBasicPlanPNG;
      case 'Plano Premium Mensal':
        return monthlyPremiumPlanPNG;
      case 'Plano Premium Semestral':
        return semesterPremiumPlanPNG;
      case 'Plano Premium Anual':
        return anualPremiumPlanPNG;
      case 'Montagem de 5 looks':
        return card5Looks;
      case 'Montagem de 10 looks':
        return card10Looks;
      case 'Montagem de 15 looks':
        return card15Looks;
      case 'Remocao de fundo':
        return removalBgPNG;
      case '50 Removedores de fundo':
        return removalBg50PNG;
      case '100 removedores de fundo':
        return removalBg100PNG;
      case '10 Provadores virtuais':
        return virtualTryOn10PNG;
      case '20 Provadores virtuais':
        return virtualTryOn25PNG;
      case '30 Provadores virtuais':
        return virtualTryOn50PNG;
      case 'Imagem profissional':
        return profissionalImagePNG;
      case 'Diagnostico de biotipo':
        return biotypeDiagnosisPNG;
      case 'Diagnostico de estilo':
        return styleDiagnosisPNG;
      case 'Mala de viagem para 3 dias':
        return suitcase3DaysPNG;
      case 'Mala de viagem para 7 dias':
        return suitcase7DaysPNG;
      case 'Mala de viagem para 15 dias':
        return suitcase15DaysPNG;
      default:
        return '';
    }
  };

  return (
    <PaymentComponent>
      <CheckoutHeader />
      <MainSection>
        <ContainerTitleAndIcon>
          <IconConcluded src={concludedIconSVG} />
          <TextConcluded>Pagamento confirmado!</TextConcluded>
        </ContainerTitleAndIcon>
        <TextConcluded>Obrigado por comprar no Resolva!</TextConcluded>
        <ImageBanner src={purchaseImage()} alt={typeOrder} />
        <ButtonBackApp
          href={
            platform === 'ios'
              ? process.env.REACT_APP_BUNDLE_ID_IOS
              : process.env.REACT_APP_PACKAGE_ANDROID
          }
        >
          VOLTAR PARA O APP
        </ButtonBackApp>
      </MainSection>
      <FooterCheckout />
      <Confetti numberOfPieces={200} recycle={false} />
    </PaymentComponent>
  );
}
